import axios from "axios";

const JWT_TOKEN = "JWT-TOKEN";
const apiInstance = axios.create({
  withCredentials: false
});

const isEmpty = (value: string | null) =>
  !value || value.toLowerCase() === "null";

export const getToken = () => {
  try {
    const token = localStorage.getItem(JWT_TOKEN);
    return isEmpty(token) ? null : token;
  } catch (e) {
    return null;
  }
};

const authenticate = (logged: boolean) => {
  try {
    let trCookie = document.cookie.match(
      new RegExp("(^| )" + "tr_sign-up" + "=([^;]+)")
    );

    if (trCookie) {
      document.body.classList.add("session-cookie");
    }

    if (logged) {
      document.body.classList.remove("session-guest");
      document.body.classList.add("session-user");
    } else {
      document.body.classList.remove("session-user");
      document.body.classList.add("session-guest");
    }
  } catch (e) {
    return;
  }
};

const checkSession = async () => {
  const token = getToken();

  if (!token) {
    authenticate(false);
    return;
  }

  try {
    await apiInstance.post(
      "/api/user/session",
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    authenticate(true);
  } catch (e) {
    authenticate(false);
  }
};

export const initSession = () => {
  checkSession().then(() => {
    const iframe = document.createElement("iframe");
    iframe.src = `${CONFIG.ssoHost}/session`;
    iframe.style.display = "none";
    document.body.appendChild(iframe);

    window.addEventListener("message", event => {
      if (event.origin === CONFIG.ssoHost) {
        authenticate(event.data.loggedIn);
      }
    });
  });
};
